export default __webpack_public_path__ + "static/zdrowy-rozwoj-twojego-dziecka-43b38aae8299e15e7085e27709c6957d.png";